import { ReturnTrackingTriggerKey } from "@redotech/redo-flows-common/triggers";
import { SendEmailProps } from "@redotech/redo-marketing-core-common/email/send-email-props";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const triggerEmailFlowPreview = {
  name: "triggerEmailFlowPreview" as const,
  input: z.object({
    returnId: zExt.objectId(),
    triggerKey: createEnum(Object.values(ReturnTrackingTriggerKey)),
  }),
  output: SendEmailProps.nullable(),
};
